<div class="modal-header">
    <h4 class="modal-title">{{ "national_projects.comments" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body">
    <adaa-comments
        titleToken="createdByUserName"
        dateToken="creationDate"
        messageToken="comments"
        [title]="undefined"
        [showNumber]="true"
        [comments]="comments"
    />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
</div>
